import { useEffect, useState } from 'react';
import AddBtn from '../../components/common/AddBtn';
import Pagination from '../../components/common/Pagination';
import BreadCrumb from '../../components/template/BreadCrumb';
import Header from '../../components/template/Header';
import {
  LINK_URL,
  PAGE_SINGLE_TITLE,
  PAGE_TITLE,
  SIDEBAR_OPTIONS,
  inputFields,
} from '../../shared/enums/activitycycles_enum';
import {
  useAllActivitys,
  useAllActivitysByCycle,
} from '../../shared/hooks/UseActivity';
import {
  useAllActivitycycles,
  useGetDropdownOptions,
  useUpdateActivitycycle,
} from '../../shared/hooks/UseActivitycycle';

import {
  useAllComments,
  useCreateComment,
} from '../../shared/hooks/UseComment';

import { Form, Formik } from 'formik';
import moment from 'moment';
import ReactModal from 'react-modal';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import * as Yup from 'yup';
import ExportComponent from '../../components/common/ExportComponent';
import FilterDateComponent from '../../components/common/FilterDateComponent';
import SingleView from '../../components/common/SingleView';
import { TextArea } from '../../components/Form/Form';
import Spinner from '../../components/layout/Spinner';
import { UseDataForExcel, UseFilter } from '../../shared/hooks/UseExcel';
import EnhancedActivityCyclesSection from './_components/Table-View';

const AllActivitycycles = ({}) => {
  const [data, setPageNumber, deleteBtnClicked, reloadData, setReloadData] =
    useAllActivitycycles();

  const LIMIT = new URLSearchParams(window.location.search).get('limit') || 10;

  const [] = useAllActivitys();
  const [updateData] = useUpdateActivitycycle();

  const {
    activitycycles_loading,
    activitycycles,
    total_activitycycles,
    page,
    pages,
  } = data;

  const [comment_data, setActivity, setReloadComments] = useAllComments();
  const [activity_data, setAcvtivityCycle, setReloadActivity] =
    useAllActivitysByCycle();
  const { comments, comments_loading } = comment_data;
  const { activitys, activitys_loading } = activity_data;
  const [commentData, addData] = useCreateComment();
  const submitFormClicked = async (values) => {
    // const data = await convertToFormData({ values, featuredImage });
    await addData(values);
    setReloadComments(true);

    // history.push(`/${LINK_URL}`);
  };

  const [dropdownOptions, loadOptions] = useGetDropdownOptions();

  const [modal, setModal] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [editId, setEditId] = useState(null);
  const [editField, setEditField] = useState(null);

  const [newStatus, setNewStatus] = useState(null);
  const [newValues, setNewValues] = useState(null);
  const [loadingActivityStatus, setLoadingActivityStatus] = useState(false);

  const [isOverdue, setIsOverdue] = useState(false);

  const [showtotalEstimateTime, setShowtotalEstimateTime] = useState(0);

  useEffect(() => {
    if (activitys && activitys.length > 0) {
      let totalEstimateActivitycycleTime =
        activitys &&
        activitys
          .map((item) => Number(item.estimated_time))
          .reduce((accum, curr) => {
            return accum + curr;
          });
      setShowtotalEstimateTime(totalEstimateActivitycycleTime);
    } else {
      setShowtotalEstimateTime(0);
    }
  }, [activitys]);

  const updateStatus = async (id, status) => {
    // console.log("ID", id, value);
    if (id && status) {
      setLoadingActivityStatus(true);
      const newForm = new FormData();
      newForm.append('values', JSON.stringify(status));
      await updateData(id, newForm);
      await setReloadData(true);
      setEditId(null);
      setLoadingActivityStatus(false);
    } else {
      setEditId(null);
    }
  };

  console.log('comments', comments);

  const [exportXLSXData] = UseFilter();

  const [convertToReadable, exportData] = UseDataForExcel();

  useEffect(() => {
    if (activitycycles) {
      convertToReadable(activitycycles, inputFields);
    }
  }, [activitycycles]);

  const handleOnExport = () => {
    exportXLSXData(exportData, 'Activity Cycles', 'activity-cycle');
  };
  const userData = useSelector((state) => state.auth);
  const { user } = userData;

  return (
    <div className='pace-done'>
      <div>
        <Header />
        <BreadCrumb
          title={PAGE_TITLE}
          mainLinkTitle='Dashboard'
          mainLinkUrl='/dashboard'
          activeLink={PAGE_TITLE}
        />
        <ExportComponent handleOnExport={handleOnExport} />
        {user && (
          <FilterDateComponent
            link='/activity-cycles'
            // showOwn={true}
            // searchParams={{ term: "assigned_to", value: user._id }}
          />
        )}

        <EnhancedActivityCyclesSection
          SIDEBAR_OPTIONS={SIDEBAR_OPTIONS}
          dropdownOptions={dropdownOptions}
          loadOptions={loadOptions}
          total_activitycycles={total_activitycycles}
          activitycycles={activitycycles}
          activitycycles_loading={activitycycles_loading}
          page={page}
          pages={pages}
          setPageNumber={setPageNumber}
          LIMIT={LIMIT}
          deleteBtnClicked={deleteBtnClicked}
          updateStatus={updateStatus}
          setModal={setModal}
          setModalData={setModalData}
          setActivity={setActivity}
          setAcvtivityCycle={setAcvtivityCycle}
          loadingActivityStatus={loadingActivityStatus}
          reloadData={reloadData}
          LINK_URL={LINK_URL}
          PAGE_SINGLE_TITLE={PAGE_SINGLE_TITLE}
          Pagination={Pagination}
          AddBtn={AddBtn}
          Spinner={Spinner}
        />
      </div>
      <ReactModal
        isOpen={modal}
        contentLabel='Modal'
        className='Modal2'
        overlayClassName='Overlay'
        onRequestClose={() => {
          setModal(false);
        }}
      >
        <div className='quick-view'>
          <div className='qv-header'>
            <div className='title'> {PAGE_SINGLE_TITLE} </div>
            <div>
              <button
                onClick={() => {
                  setModal(false);
                }}
                className='btn btn-primary'
              >
                <i className='fa fa-times'></i>
              </button>
            </div>
          </div>
          {modalData && (
            <>
              <div className='qv-body'>
                <SingleView
                  hideGallery={true}
                  data={modalData}
                  inputFields={inputFields}
                  label={PAGE_SINGLE_TITLE}
                  link={LINK_URL}
                  id={modalData._id}
                  hideAllBtn={true}
                  col={12}
                >
                  <div className='col-md-6'>
                    <div
                      style={{
                        borderBottom: '1px solid rgb(241, 241, 241)',
                        paddingBottom: 5,
                        paddingTop: 5,
                      }}
                    >
                      <div className='title'>Total Estimate Time</div>
                      <div
                        style={{
                          marginBottom: 10,
                          fontWeight: 500,
                          fontSize: 16,
                        }}
                      >
                        {showtotalEstimateTime} mins
                      </div>
                    </div>
                  </div>
                </SingleView>

                <div className='card'>
                  <div className='card-body'>
                    <table className='table table-stripped'>
                      <thead>
                        <tr>
                          <th>#</th>
                          <th> Task Name </th>
                          <th> Assigned To </th>
                          <th> Due Time </th>
                          <th> Estimate Time </th>
                          <th> Client </th>
                          <th> Process </th>
                          <th> Activity Status </th>
                          <th> Review Status </th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {!activitys_loading ? (
                          <>
                            {activitys &&
                              activitys.map((single, index) => {
                                return (
                                  <tr>
                                    <td> {index + 1 + (page - 1) * LIMIT} </td>
                                    <td>
                                      {' '}
                                      {single.task_name}
                                      <a
                                        onClick={() => {
                                          setEditField('task_name');
                                          setEditId(single._id);
                                          setNewValues({
                                            task_name: single.task_name,
                                          });
                                        }}
                                      >
                                        {' '}
                                        <i className='fa fa-edit'></i>{' '}
                                      </a>
                                    </td>
                                    <td>
                                      {single.assigned_to &&
                                        single.assigned_to.name}
                                    </td>
                                    <td>
                                      {single.due_time &&
                                        moment(single.due_time)
                                          .utc()
                                          .format('DD-MM-YYYY hh:mm A')}
                                    </td>
                                    <td>{single.estimated_time}</td>
                                    <td>
                                      {' '}
                                      {single.client && single.client.name}{' '}
                                    </td>
                                    <td>
                                      {single.process && single.process.name}
                                    </td>
                                    <td>
                                      {single.activity_status &&
                                        single.activity_status.name}
                                    </td>
                                    <td>
                                      {single.review_status &&
                                        single.review_status.name}
                                    </td>
                                    <td>
                                      <Link
                                        to={`/activitys/${single._id}/view`}
                                        className='btn btn-sm btn-success'
                                      >
                                        {' '}
                                        <i className='fa fa-eye'></i>{' '}
                                      </Link>
                                    </td>
                                  </tr>
                                );
                              })}
                          </>
                        ) : (
                          <>
                            <p> Loading... </p>
                          </>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className='card'>
                  <div className='card-body'>
                    <Formik
                      initialValues={{
                        comment: '',
                      }}
                      validationSchema={Yup.object({
                        comment: Yup.string().required('Required'),
                      })}
                      onSubmit={async (
                        values,
                        { setSubmitting, resetForm }
                      ) => {
                        setSubmitting(true);
                        values.activity = modalData._id;
                        if (modalData.activity_cycle) {
                          values.activity_cycle = modalData.activity_cycle;
                        }
                        await submitFormClicked(values);
                        resetForm();
                        setSubmitting(false);
                      }}
                    >
                      {(formik) => {
                        console.log(formik);
                        return (
                          <Form>
                            <div className='row align-items-center'>
                              <div className='col-md-9'>
                                <TextArea
                                  label='Comment'
                                  name='comment'
                                  type='text'
                                />
                              </div>
                              <div className='col-md-3'>
                                <button
                                  type='submit'
                                  className='btn btn-success'
                                >
                                  {' '}
                                  {formik.isSubmitting
                                    ? 'SAVING...'
                                    : 'SAVE'}{' '}
                                </button>
                              </div>
                            </div>
                          </Form>
                        );
                      }}
                    </Formik>
                  </div>
                </div>
                <div className='card'>
                  <div className='card-body'>
                    <table className='table table-stripped'>
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Comment</th>
                          <th>Comment By</th>
                          <th>Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {!comments_loading ? (
                          <>
                            {comments &&
                              comments.map((item, index) => {
                                return (
                                  <tr>
                                    <td> {index + 1} </td>
                                    <td> {item.comment} </td>
                                    <td>
                                      {' '}
                                      {item.created_by &&
                                        item.created_by.name}{' '}
                                    </td>
                                    <td>
                                      {' '}
                                      {item.createdAt &&
                                        moment(item.createdAt).format(
                                          'DD-MM-YYYY hh:mm A'
                                        )}{' '}
                                    </td>
                                  </tr>
                                );
                              })}
                          </>
                        ) : (
                          <>
                            <p> Loading... </p>
                          </>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </ReactModal>
    </div>
  );
};

export default AllActivitycycles;
